<template>
  <require from="controls/bs-form-input"></require>
  <require from="controls/bs-form-select"></require>

  <div class="country-approval-panel">
    <template if.bind="!disabled || !model.status">
      <bs-form-select label="${approverGroupLabel}" placeholder="Select approver" value.bind="approver & validate" options.bind="countryApprovers" matcher.bind="keywordsItemMatcher" name-path="name" disabled.bind="disabled" if.bind="selectionRequired"></bs-form-select>
      <bs-form-input type="text" label="${approverGroupLabel}" value.bind="approverNames" disabled="true" else></bs-form-input>
    </template>
    <div class="country-approval-panel__status-box" else>
      <div class="d-flex">
        <span class="form-content w-auto --noborder form-control-plaintext">Status</span>
        <span class="form-content w-auto --noborder text-right ml-auto text-nowrap" title="${model.status.name}">
          <span class="d-none d-sm-inline at-approval-status ${statusClass}">${model.status.name}</span>
          <i class="ai-approval-status ${statusClass}"></i>
        </span>
      </div>
      <div class="country-approval-panel__status-table">
        <div class="form-row" repeat.for="data of countryApproverData">
          <div class="col-auto __name">${data.name}</div>
          <div class="col-auto ml-auto __status" if.bind="data.status">${data.status}</div>
          <div class="col-12 __comment" if.bind="data.comment">${data.comment}</div>
        </div>
      </div>
    </div>
  </div>
</template>
